import React from 'react';
import { withRouter } from 'react-router';
import { compose, graphql } from 'react-apollo';
import { connect } from 'react-redux';
import { assignmentPreviewData } from 'legacy/src/queries';
import withLearnosityConfig from 'legacy-src/utility/withLearnosityConfig';
import { useRestoreMathJax } from 'chameleon/ui-stack/hooks/useMathJaxReplace';
import PreviewPlayer from './main';

const AssignmentPreviewPlayer = (props) => {
  const {
    onQuestionChanged,
    questions,
    loadingAssignmentData,
    loadingQuestionData,
    getCurrentQuestionIndex,
  } = props;

  useRestoreMathJax();

  return (
    <PreviewPlayer
      {...props}
      loading={loadingAssignmentData || loadingQuestionData}
      onQuestionChanged={(questionId) => {
        if (onQuestionChanged) {
          const currentQuestion = questions.find(
            (question) => question.itemId === questionId,
          );
          onQuestionChanged(currentQuestion);
        }
        if (getCurrentQuestionIndex) {
          const questionIds = questions.map((item) => item.itemId);
          const getQuestionIndex = questionIds.indexOf(questionId);
          getCurrentQuestionIndex(getQuestionIndex);
        }
      }}
    />
  );
};

const withAssignmentPreview = graphql(assignmentPreviewData, {
  options: ({ assignmentId, learnosityConfig }) => ({
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only',
    variables: {
      assignmentId,
      config: JSON.stringify(learnosityConfig),
    },
  }),
  props: ({ data }) => {
    const { loading, assignmentPreview } = data;

    if (assignmentPreview) {
      const { learnositySignedRequest, allowCalculatorForItems } =
        assignmentPreview;

      return {
        loadingAssignmentData: loading,
        learnosityServerData: JSON.parse(learnositySignedRequest),
        allowCalculatorForItems,
      };
    }
  },
});

export default compose(
  withRouter,
  connect((state) => state),
  withLearnosityConfig(),
  withAssignmentPreview,
)(AssignmentPreviewPlayer);
